import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface VersionProps {
  active: boolean;
  id: number;
  name: string;
  time: string;
  user: string;
  reverted: boolean;
}

function Version({active, id, name, time, user, reverted}: VersionProps): JSX.Element {
  return (
    <tr
      // eslint-disable-next-line react/no-unknown-property
      version-id={id}
      className={classNames(
        active ? css(styles.selectedVersionRow) : active,
        {'is-reverted': reverted, faded: reverted},
        'version-row'
      )}
      {...getTestProps({component: 'Version', element: 'root'})}
    >
      <td className="name" title={name}>
        <div>{name}</div>
      </td>
      <td className="user" title={user}>
        <div className="text-center">{user}</div>
      </td>
      <td className="time" title={time}>
        <div className="text-right">{time}</div>
      </td>
    </tr>
  );
}

const styles = StyleSheet.create({
  selectedVersionRow: {
    color: '#000DB5',
    backgroundColor: '#E8EDFF',
    fontWeight: 600,
  },
});

export default makeDeprecatedJadeStyleTemplate<VersionProps>(Version);
